/* eslint-disable no-param-reassign */

const withFetcher = fetcher => (target) => {
  target.fetcher = fetcher;

  return target;
};

export default withFetcher;